module.exports = __webpack_public_path__ + "img/金豐ai公版icon.f9e14a1b.svg";